export default __webpack_public_path__ + "static/plume-poster-a1939e02e418e1577ac2ee3500920d61.jpg";